/**
 * Created by Owner on 2016/8/9.
 */
import {Component} from '@angular/core';
import {AlertController, NavParams} from 'ionic-angular';
import {AppConfigService} from "../../services/appConfig.service";
import {UserService} from "../../services/user.services";
import {AppDialog} from "../../component/appDialog";

@Component({
  templateUrl: 'agencyUserRebate.html',
  selector: 'agency-user-rebate-page',
})
export class AgencyUserRebatePage {
  loginName: string;
  nickName: string;
  id: string;
  pointssc: number = 0;
  // point115: number = 0;
  // pointdp: number = 0;
  selssc: any = [];
  // sel115: any = [];
  // seldp: any = [];

  constructor(private navParams: NavParams, private alertCtrl: AlertController, private userService: UserService) {
    let data = navParams.get("data");
    this.loginName = data.loginname;
    this.nickName = data.nickname;
    this.id = data.id;
    this.initService();
  }

  initService() {
    let requestData: any = {
      id: this.id
    };

    this.userService.agentUserPointInit(requestData, this.alertCtrl).then(data=> {
      if (!data["msg"]) {
        this.selssc = data["selssc"];
        // this.sel115 = data["sel115"];
        // this.seldp = data["seldp"];
        this.pointssc = data["optuser"]["pointssc"];
        // this.point115 = data["optuser"]["point115"];
        // this.pointdp = data["optuser"]["pointdp"];
      } else {
        AppDialog.alert({
          alertCtrl: this.alertCtrl,
          message: data["msg"]
        });
      }
    });
  }

  submitFn() {
    let requestData: any = {
      aopointssc: this.pointssc,
      // aopoint115: this.point115,
      // aopointdp: this.pointdp,
    };

    this.userService.agentUserPointUpdate(requestData, this.alertCtrl).then(data=> {
      if (!data["msg"]) {
        AppDialog.alert({
          alertCtrl: this.alertCtrl,
          message: "Cập nhật thành công"
        });
      } else {
        AppDialog.alert({
          alertCtrl: this.alertCtrl,
          message: data["msg"]
        });
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/agencyUserRebate/agencyUserRebate.ts